export function mediaAccordion() {
    const accordionDetails = document.querySelectorAll('.media-accordion details');
    
    if (accordionDetails.length === 0) return;
    
    const imageMap = new Map();
    accordionDetails.forEach(details => {
        const imageClassName = details.getAttribute('data-image');
        const image = document.querySelector(`.${imageClassName}`);
        if (image) imageMap.set(details, image);
    });
    
    function updateImageVisibility() {
        imageMap.forEach((image, details) => {
            image.classList.toggle('is-visible', details.open);
        });
    }
    
    accordionDetails[0].open = true;
    updateImageVisibility();
    
    accordionDetails.forEach(details => {
        details.addEventListener('click', (e) => {
            if (details.open && e.target.closest('summary')) {
                e.preventDefault();
            }
        });

        details.addEventListener('toggle', () => {
            if (details.open) {
                accordionDetails.forEach(other => {
                    if (other !== details) other.open = false;
                });
            }
            updateImageVisibility();
        });
    });
}